import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CalendarPlanThemeActivities } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { CalendarPlanStoreState } from './typings';

const initialState: CalendarPlanStoreState = {
    themeActivities: {},
    themeActivitiesLoadingStatus: LOADING_STATUSES.UNSENT,
};

const slice = createSlice({
    name: 'CALENDAR_PLAN',
    initialState: initialState,
    reducers: {
        // Параметры нужны для саги
        /* eslint-disable @typescript-eslint/no-unused-vars */
        getThemeActivitiesRequest: (
            state: CalendarPlanStoreState,
            action: PayloadAction<{
                themeIds: string[];
            }>
        ) => {
            state.themeActivitiesLoadingStatus = LOADING_STATUSES.LOADING;
        },

        getThemeActivitiesSuccess: (
            state: CalendarPlanStoreState,
            action: PayloadAction<{
                themes: CalendarPlanThemeActivities[];
            }>
        ) => {
            const { themes } = action.payload;

            themes.forEach((theme) => {
                state.themeActivities[theme.id] = theme;
            });

            state.themeActivitiesLoadingStatus = LOADING_STATUSES.SUCCESS;
        },
        /* eslint-enable @typescript-eslint/no-unused-vars */
    },
});

export const calendarPlanActions = slice.actions;
export const calendarPlanReducer = slice.reducer;
